import { mainMappingVariable } from './types';
var existsAndString = function (aValue) {
    return Boolean(aValue) && typeof aValue === 'string';
};
export var insertMainMappingToSubMappings = function (mapping, subMappings) {
    if (!existsAndString(mapping) || !existsAndString(subMappings)) {
        throw new Error('Mapping or subMappings are not defined');
    }
    if (!subMappings.includes(mainMappingVariable)) {
        throw new Error("There is not main mapping pattern in the subMapping (".concat(mainMappingVariable, ")"));
    }
    return subMappings.replace(mainMappingVariable, mapping);
};
//# sourceMappingURL=insert-main-mapping-to-sub-mappings.js.map